module.exports = __webpack_public_path__ + "static/media/loader.14a20030.gif";